import { DiscountType, PromotionType } from '@atlassian/mpac-api-client';
import { DateUtils } from '@atlassian/mpac-utils';
import { discountTypeLabelMap } from "../constants";
export var getDiscountTypeLabel = function getDiscountTypeLabel(createPromotionData) {
  return createPromotionData.discountType === DiscountType.FLAT_DISCOUNT ? "".concat(discountTypeLabelMap[createPromotionData.discountType], " ").concat(createPromotionData.discountPercent, "%") : discountTypeLabelMap[createPromotionData.discountType];
};
export var getStartDateLabel = function getStartDateLabel(createPromotionData) {
  return PromotionType.SINGLE_USE_PROMOTION === createPromotionData.promotionType ? 'Today' : DateUtils.longDate(createPromotionData.startDate);
};
export var getEligibleApps = function getEligibleApps(eligibleApps) {
  return eligibleApps.map(function (app) {
    return app.label;
  }).join(', ');
};